import { apiUrlPrefix } from '../../../config';

// This is retrieving all the reports from users to an admin level
const fetchManagerReports = async (discussionId: any, communityId: any, setReports: any) => {
    try {

        const dId = discussionId || "";
        const cId = communityId || "";

        const response = await fetch(
            `${apiUrlPrefix}Report/getAllCommunityReports?discussionId=${dId}&communityId=${cId}`,
            {
                method: "GET",
                headers: {
                    'Content-Type': 'application/json',
                },
            }
        );
        if (response.ok) {
            const data = await response.json();
            setReports(data);
            return data; // Return the data so your component can use it
        } else {
            console.error("Failed to fetch discussions");
        }
    } catch (error) {
        console.error("Error fetching discussions:", error);
    }
};

export default fetchManagerReports;